import {Component} from 'react';
import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';

const stateDisplay = {
  CREATED: {
    symbol: 'symbol-status-clock',
    label: 'document.state.CREATED'
  },
  NOT_APPLICABLE: {
    symbol: 'symbol-status-not-applicable',
    label: 'document.state.NOT_APPLICABLE'
  },
  AWAITING_GATHERING: {
    symbol: 'symbol-status-clock',
    label: 'document.state.AWAITING_GATHERING'
  },
  MISSING: {
    symbol: 'symbol-status-cross',
    label: 'document.state.MISSING'
  },
  AWAITING_COMPLETION: {
    symbol: 'symbol-status-cross',
    label: 'document.state.AWAITING_COMPLETION'
  },
  AWAITING_SIGNATURE: {
    symbol: 'symbol-status-cross',
    label: 'document.state.AWAITING_SIGNATURE'
  },
  AWAITING_VALIDATION: {
    symbol: 'symbol-status-clock',
    label: 'document.state.AWAITING_VALIDATION'
  },
  VALID: {
    symbol: 'symbol-status-check',
    label: 'document.state.VALID'
  },
  REJECTED: {
    symbol: 'symbol-status-cross',
    label: 'document.state.REJECTED'
  },
  EXPIRED: {
    symbol: 'symbol-status-cross',
    label: 'document.state.EXPIRED'
  },
  ALMOST_EXPIRED: {
    symbol: 'symbol-status-warning',
    label: 'document.state.ALMOST_EXPIRED'
  },
  SIGNED: {
    symbol: 'symbol-status-check',
    label: 'document.state.SIGNED'
  }
};

class DocumentState extends Component {
  render() {
    const display = stateDisplay[this.props.state];
    return (<span className="inline-container">
      <span
        data-id="symbol"
        className={`symbol ${display.symbol}`}
      />
      <Translate value={display.label}/>
    </span>);
  }
}

DocumentState.propTypes = {
  state: PropTypes.string.isRequired
};

export default DocumentState;
